// extracted by mini-css-extract-plugin
export default {"container":"dat_3jInb"};